import { Loader2 } from 'lucide-react';

import { useGetMobileInventorIntegration } from '~entities/mobile-inventor-push/api/get-integration';
import { useUpdateMobileInventorIntegration } from '~entities/mobile-inventor-push/api/update-integration';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import { Switch } from '~shared/shadcn/ui/switch';

export const PushIntegrationSettings = () => {
  const { data: integration } = useGetMobileInventorIntegration();
  const updateIntegration = useUpdateMobileInventorIntegration();

  if (!integration?.configured) {
    return null;
  }

  const isEnabled = integration.mobileInventorEnabled === true;
  // Treat undefined/null as not connected — only an explicit true means ready.
  const appConnected = integration.appConnected === true;
  // Always allow turning push OFF (even if MI later disconnects). Only block
  // turning ON until the app is confirmed connected.
  const canEnable = appConnected;
  const switchDisabled =
    updateIntegration.isPending || (!isEnabled && !canEnable);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Push notification settings</CardTitle>
        <CardDescription>
          Enable push notifications for this studio. Requires a configured
          location ID and Mobile Inventor app.
          {integration.appName ? ` Connected app: ${integration.appName}.` : ''}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className='flex items-center justify-between gap-4'>
          <div>
            <p className='font-medium'>Enable push notifications</p>
            <p className='text-sm text-muted-foreground'>
              {isEnabled
                ? 'Turn off to stop all automated and manual push sends for this studio.'
                : canEnable
                  ? 'Turn on to allow automated and manual push sends for this studio.'
                  : 'Connect your Mobile Inventor app before enabling push notifications.'}
            </p>
          </div>
          <div className='relative flex items-center'>
            {updateIntegration.isPending ? (
              <Loader2 className='absolute -left-7 size-4 animate-spin' />
            ) : null}
            <Switch
              checked={isEnabled}
              disabled={switchDisabled}
              onCheckedChange={(enabled) => {
                if (enabled && !canEnable) return;
                updateIntegration.mutate(enabled);
              }}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
